<template>
  <div class="home">
    <a href="https://apps.apple.com/us/app/cogito-note-revision-ia/id6739225998"><img style="height: 49px; width: 124px;" src="./../assets/ios.svg" /></a>
  </div>
  <footer class="footer-links">
    <div class="footer-content">
      <span class="footer-copy">© Cognify 2025</span>
      <span class="footer-separator">•</span>
      <router-link to="/privacy">Privacy Policy</router-link>
      <span class="footer-separator">•</span>
      <router-link to="/terms">Terms</router-link>
      <span class="footer-separator">•</span>
      <router-link to="/help">Help</router-link>
      <span class="footer-separator">•</span>
      <router-link to="/legal">Legal Notice</router-link>
    </div>
</footer>
</template>

<script>
export default {
  name: "HomePage",
};
</script>

<style scoped>
.home {
  text-align: center;
  padding: 20px;
}

.footer-links {
  font-family: Arial, sans-serif;
  font-size: 13px;
  text-align: center;
  padding-top: 20px;
  padding-bottom: 30px;
  position: fixed;
  bottom: 0;
  width: 100%;
  background-color: transparent;
  transition: color 0.3s;
}

@media (prefers-color-scheme: light) {
  .footer-links,
  .footer-links a {
    color: black;
  }
}

@media (prefers-color-scheme: dark) {
  .footer-links,
  .footer-links a {
    color: white;
  }
}

.footer-content {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 10px;
  row-gap: 6px;
  max-width: 100%;
  padding: 0 20px;
  line-height: 1.6;
}

.footer-content a {
  text-decoration: none;
  opacity: 0.7;
  transition: opacity 0.2s;
}

.footer-content a:hover {
  opacity: 1;
  text-decoration: underline;
}

.footer-copy {
  opacity: 0.7;
}

.footer-separator {
  opacity: 0.4;
}

h1 {
  font-size: 24px;
}

p {
  font-size: 16px;
  margin-top: 10px;
}
</style>